module.exports = __webpack_public_path__ + "img/tool-tools-portfolio.ea94ba24.svg";